import React from 'react';
import DragDropListsCore from '@components-clean/core/drag-drop-lists-core';
import { DragDropListItemProps } from '@components-clean/core/drag-drop-lists-core/drag-drop-lists-core.interface';
import { useTranslation } from '@hooks/index';
import { DataReviewTableFields } from '@queries/generated/fragments.generated';

const DataViewDatatables = ({
    studyDataViewDataTables,
    dataViewDataTableIds,
}: {
    studyDataViewDataTables: DataReviewTableFields[];
    dataViewDataTableIds?: string[];
}) => {
    const { t } = useTranslation();

    const dataViewConfigDTs = dataViewDataTableIds?.map((dt) => {
        const dataViewDT = studyDataViewDataTables.find((item) => item?.id === dt);
        return {
            active: dataViewDT?.active,
            Id: dataViewDT?.id as string,
            title: dataViewDT?.name,
        };
    });

    return (
        <div className="k-h-full">
            <DragDropListsCore
                list1Header={t('admin:dataTables')}
                list1Items={dataViewConfigDTs as DragDropListItemProps[]}
                idField="Id"
                disabled
            />
        </div>
    );
};
export { DataViewDatatables };
